import './Page.css'

const Page = ({ children }) => {
  return (
    <div className="Page" >
      <div>
        {children}
      </div>
    </div>
  );
};

export default Page;
